import { sagaCreator, stateSelector } from 'redux-saga-kit';
import { all, put, select, take } from 'redux-saga/effects';
import { getUnavailableDishes } from '../../utils/OrderHistoryUtils';
import {
  cancelMergeOrder,
  continueWithoutUnavailableDishes,
  mergeExistingOrder,
  setUnavailableItems,
} from '../engine/actions/OrderHistoryActions';
import { cartUpsert } from '../engine/actions/OrderActions';
import { getChoicesStr } from '../../utils/DishUtils';
import { getBasicDisplayableOrderItem } from '../../utils/ItemUtils';
import { getPriceByItemId } from '../../utils/MenuUtils';
import { displayModal } from '../engine/actions/SessionActions';
import { Modals } from '../../utils/constants';
import { deliveryTypeSelector } from '../engine/selectors/deliveryTypeSelector';

const onMergeExistingOrder = () =>
  function*({ payload }) {
    const { orderItems: orderItemsFromExistingOrder } = payload;
    const itemsHash = yield select(stateSelector('session.itemsHash'));
    const menu = yield select(stateSelector('session.menu'));
    const { currency } = yield select(stateSelector('session.organization'));
    const locale = yield select(stateSelector('session.organization.locale'));
    const deliveryType = deliveryTypeSelector(yield select());
    const unavailableDishes = getUnavailableDishes({
      orderItems: orderItemsFromExistingOrder,
      menu,
      itemsHash,
      deliveryType,
    });
    const i18n = { get: str => str };
    const decoratedUnavailableDishes = unavailableDishes.map(unavailableDish => {
      return {
        item: getBasicDisplayableOrderItem(unavailableDish.orderItem, locale, itemsHash),
        variations: getChoicesStr({
          orderItem: unavailableDish.orderItem,
          itemsHash,
          currency,
          locale,
          i18n,
        }),
        unavailableVariations: unavailableDish.variations.map(v => itemsHash[v].title[locale]),
      };
    });

    const availableDishes = [
      ...orderItemsFromExistingOrder.filter(
        orderItemFromExistingOrder =>
          !unavailableDishes.map(unavailableDish => unavailableDish.orderItem).includes(orderItemFromExistingOrder),
      ),
    ];

    if (decoratedUnavailableDishes.length > 0) {
      yield all([
        put(setUnavailableItems({ items: decoratedUnavailableDishes })),
        put(displayModal({ modal: Modals.UNAVAILABLE_DISHES })),
      ]);
      const action = yield take([continueWithoutUnavailableDishes, cancelMergeOrder]);
      if (action.type === cancelMergeOrder.toString()) {
        return;
      }
    }

    const actions = availableDishes.map(availableDish => {
      const orderItem = (function() {
        return availableDish.price
          ? { ...availableDish, price: getPriceByItemId(availableDish, itemsHash) }
          : availableDish;
      })();

      return put(cartUpsert({ cartIndex: -1, orderItem }));
    });

    yield all(actions);
  };

export default sagaCreator({
  [mergeExistingOrder]: { handler: onMergeExistingOrder },
});
